import DiscordWidget from './DiscordWidget.vue';

export { DiscordWidget };
export default DiscordWidget;
